module.exports = __webpack_public_path__ + "static/cartabsLayout2Back-7e49903b56de8f9af9cd37c419680f60.png";